export interface IUrlOptions {
  /** Indica si se agrega el parámetro "back" con la url actual */
  back?: boolean;

  /** indica que se incluya toda la ruta completa (no relativa) */
  fullUrl?: boolean;
}

export default class UrlService {
  /** devuelve los parámetros pasador por URI */
  query = () : any => {
    const query : any = { };
    window.location.search.slice(1).split('&').forEach(p => { 
      query[p.split('=')[0]] = decodeURIComponent(p.split('=')[1])
    });
    return query;
  }

  /** construye una url con parámetros */
  build = (url: string, parms?: any, options?: IUrlOptions) : string => {
    let parmsString = '?';
    if (parms)
      Object.getOwnPropertyNames(parms).forEach(f => parmsString += `&${f}=${encodeURIComponent(parms[f])}`);
      
    if (options) {
      if (!!options.back) parmsString += `&back=${encodeURIComponent(this.url())}`;
      if (options.fullUrl && !url.startsWith('http')) url = `${window.location.origin}${url}`;
    }
    parmsString = parmsString.replace('?&', '?');
    if (parmsString === '?') parmsString = '';
    
    return `${url}${parmsString}`;
  }

  /** redirige a una url */
  redirect = (url: string, parms?: any, options?: IUrlOptions) => {
    window.location.href = this.build(url, parms, options);
  }

  /** devuelve la url completa actual */
  url = () => window.location.pathname + window.location.search;
}